import script from "./adjustments-account-select.vue?vue&type=script&setup=true&lang=ts"
export * from "./adjustments-account-select.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__